import { MarkdownRenderer } from '@web/app/features/agents/components/MarkdownRenderer';

const GEMINI_KEY_INFO_CONTENT = `
# Gemini API Key 발급 방법

Google AI Studio에서 Gemini API 키를 발급받으실 수 있습니다.

## 발급 절차

1. [Google AI Studio](https://aistudio.google.com/)에 접속
2. 좌측 메뉴에서 "Get API key" 선택
3. "Create API key" 버튼 클릭
4. 생성된 API 키 복사

## 주의사항

- API 키는 안전하게 보관하세요
- 공개 저장소에 커밋하지 마세요
- 주기적으로 키를 갱신하는 것을 권장합니다

## 사용 방법

1. 발급받은 API 키를 아래 입력란에 입력
2. 저장 버튼 클릭
3. AI Studio 기능에서 Gemini 모델 사용 가능
`;

export const GeminiKeyInfoContent = () => {
    return (
        <div className="mt-5">
            <MarkdownRenderer content={GEMINI_KEY_INFO_CONTENT} isQuery={false} messageId="gemini-key-info" />
        </div>
    );
};
